/* eslint-disable */
import { Select, DatePicker, Divider } from "antd";
import { forwardRef, useEffect, useState } from "react";

import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import MaintenceReport from "./component/MaintenceReport";
import MaintenceHistoryReport from "./component/MaintenceHistoryReport";
import JobRequests from "./component/jobRequests";
import JobRequestsMonthlyWorker from "./component/JobRequestsMonthlyWorker";
import JobRequestsMonthlyWorkerCompleted from "./component/JobRequestsMonthlyWorkerCompleted";
import JobRequestsVendorDays from "./component/jobRequestsVendorDay";
import MaintenanceVendorCostReport from "./component/maintenanceVendorCostReport";
import commonFn from "@/utils/commonFn";
import './component/index.scss'
const { RangePicker } = DatePicker;

const Main = forwardRef(() => {
  const [error, setError] = useState(null);
  const [selectedReport, setSelectedReport] = useState(null);

  const reportList = [
    { label: "Maintenance Report", value: "Maintenance Report" },
    { label: "Maintenance History Report", value: "Maintenance History Report" },
    { label: "Maintenance Vendor Report", value: "Maintenance Vendor Report" },
    { label: "Maintenance Vendor Invoice Report", value: "Maintenance Vendor Invoice Report" },
    // { label: "Maintenance Completed Vendor Invoice Report", value: "Maintenance Completed Vendor Invoice Report" },
    { label: "Maintenance Vendor Days Report", value: "Maintenance Vendor Days Report" },
    { label: "Maintenance Vendor Cost Report", value: "Maintenance Vendor Cost Report" }
  ];
const getAccessibleReports = () => {
  return reportList.filter(report => {
    const permissionMap = {
      "Maintenance Report": "MaintenanceReport",
      "Maintenance History Report": "MaintenanceHistoryReport",
      "Maintenance Vendor Report": "MaintenanceVendorReport",
      "Maintenance Vendor Invoice Report": "MaintenanceVendorInvoiceReport",
      "Maintenance Vendor Days Report": "MaintenanceVendorDaysReport",
      "Maintenance Vendor Cost Report": "MaintenanceVendorCostReport"
    };
    return commonFn.btnAuthorityFlag(permissionMap[report.value]);
  });
};
    const onTypeChange = (value, option) => {
    setSelectedReport(option.label);
    console.log("Selected:", option.label);
  };
  
  const stepSearchChange = (value) => {
   
  };
  useEffect(() => {
  const accessibleReports = getAccessibleReports();
  if (accessibleReports.length > 0) {
    const stillHasPermission = accessibleReports.some(
      r => r.value === selectedReport
    );
    if (!stillHasPermission) {
      setSelectedReport(accessibleReports[0].value); // 重置为第一个有权限的
    }
  }
}, [commonFn]); 



  return (
    <div>
      <div className="content">
        <h3 style={{marginRight:10}}>Report:</h3>
        <Select
          showSearch
          allowClear
          placeholder="Select a report"
          onChange={onTypeChange}
          onSearch={stepSearchChange}
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={reportList}
          style={{ width: 580,}}
        />
      </div>
      <Divider />
    <div>
        {selectedReport === "Maintenance Report"  && <MaintenceReport />  }
        {selectedReport === "Maintenance History Report"  &&  <MaintenceHistoryReport /> }
        {selectedReport === "Maintenance Vendor Report" && <JobRequests /> }
        {selectedReport === "Maintenance Vendor Invoice Report"&& <JobRequestsMonthlyWorker />  }
        {selectedReport === "Maintenance Completed Vendor Invoice Report" && <JobRequestsMonthlyWorkerCompleted /> }
        {selectedReport === "Maintenance Vendor Days Report"  && <JobRequestsVendorDays /> }
        {selectedReport === "Maintenance Vendor Cost Report" &&  <MaintenanceVendorCostReport /> }
      </div>
    </div>
  );
});
export default Main;
